import { all, takeLatest, put, call } from 'redux-saga/effects';
import {
  getCustomerPortalAvailability,
  getCustomerPortalAvailabilitySucceeded,
  getCustomerPortalAvailabilityFailed,
  createCustomerPortalSession,
  createCustomerPortalSessionSucceeded,
  createCustomerPortalSessionFailed
} from './slice';
import { onGetCustomerPortalAvailability, onCreateCustomerPortalSession } from './api';

export function* getCustomerPortalAvailabilityWorker() {
  try {
    const response = yield call(onGetCustomerPortalAvailability);
    yield put(getCustomerPortalAvailabilitySucceeded(response.data));
  } catch {
    yield put(getCustomerPortalAvailabilityFailed());
  }
}

export function* createCustomerPortalSessionWorker({ payload = {} }) {
  const { onSuccess, onFailure } = payload;
  try {
    const response = yield call(onCreateCustomerPortalSession);
    yield put(createCustomerPortalSessionSucceeded(response.data));
    onSuccess?.(response.data?.url);
  } catch {
    yield put(createCustomerPortalSessionFailed());
    onFailure?.();
  }
}

export default function* stripeSaga() {
  yield all([
    takeLatest(getCustomerPortalAvailability.type, getCustomerPortalAvailabilityWorker),
    takeLatest(createCustomerPortalSession.type, createCustomerPortalSessionWorker)
  ]);
}
